import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from '../Modal.js';
import THEME from '../../theme.js';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Input from '../Input.js';
import Button from '../Button.js';
import { validateEmail } from '@debbie/common/dist/index.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
import { ExclusiveContentBadge } from '../ExclusiveContent.js';
import { CASEWORKER_URL } from '../../config.js';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors.js';
import { hasScope } from '@debbie/common/dist/permissions/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
const InitiateDNS = (props) => {
    const collectorLoadable = useCollector(props.collectorId);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const tenantId = useSelector(selectTenantId);
    const [email, setEmail] = useState('');
    const [debtorWebappBase, setDebtorWebappBase] = useState('');
    const [creditorWebappBase, setCreditorWebappBase] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const setupURL = `${CASEWORKER_URL}/dns-setup/${tenantId}/${props.collectorId}`;
    return collector ? (submitted ? (React.createElement("div", null,
        React.createElement("h3", null, "Send dette link til den ansvarlige for DNS-ops\u00E6tningen"),
        React.createElement("a", { href: setupURL, target: "_blank" }, setupURL))) : (React.createElement("div", null,
        React.createElement("h3", null, "E-mail"),
        React.createElement("p", null,
            "Example: ",
            React.createElement("b", null, "info@example.com")),
        React.createElement(Input, { placeholder: "Outbound e-mails", value: email, onChange: (e) => setEmail(e.target.value), type: "email" }),
        React.createElement("h3", null, "Debitorweb base"),
        React.createElement("p", null,
            "Example: ",
            React.createElement("b", null, "case.example.com")),
        React.createElement(Input, { placeholder: "Debitorweb base", value: debtorWebappBase, onChange: (e) => setDebtorWebappBase(e.target.value) }),
        React.createElement("h3", null, "Kreditorweb base"),
        React.createElement("p", null,
            "Example: ",
            React.createElement("b", null, "app.example.com")),
        React.createElement(Input, { placeholder: "Kreditorweb base", value: creditorWebappBase, onChange: (e) => setCreditorWebappBase(e.target.value) }),
        React.createElement("p", null, "All three domains has to be uniquie (email, creditor and debtor webapp domain) because webapp CNAMEs will forward everything."),
        React.createElement(Button, { loading: loading, block: true, disabled: !(validateEmail(email) &&
                (validateDomain(debtorWebappBase) || !debtorWebappBase) &&
                (validateDomain(creditorWebappBase) || !creditorWebappBase)), onClick: async () => {
                setLoading(true);
                try {
                    await collectorsAPI.initiateDNS(props.collectorId, {
                        outboundEmail: email.trim(),
                        debtorWebBase: debtorWebappBase
                            ? debtorWebappBase.trim()
                            : undefined,
                        creditorWebBase: creditorWebappBase
                            ? creditorWebappBase.trim()
                            : undefined,
                    });
                    setSubmitted(true);
                }
                catch (error) {
                    console.error(error);
                    alert('Error');
                }
                setLoading(false);
            } }, "Ops\u00E6t")))) : (React.createElement(PlaceholderLoader, null));
};
const validateDomain = (domain) => {
    var without_regex = new RegExp('^([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?');
    if (domain.indexOf('http') !== -1) {
        return false;
    }
    if (domain.indexOf('@') !== -1) {
        return false;
    }
    if (domain.indexOf(':') !== -1) {
        return false;
    }
    if (domain.indexOf('/') !== -1) {
        return false;
    }
    return without_regex.test(domain);
};
export const InitiateDNSButton = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const exclusiveContent = useSelector(selectExclusiveContent);
    const me = useSelector(selectMe);
    const tenantId = useSelector(selectTenantId);
    if (!((me && exclusiveContent?.includes(me.id)) ||
        // Thor Suhr from Nuna Law
        (me?.id && ['663a6084-6027-4303-af92-59c61cf49ee2'].includes(me?.id)) ||
        (me && tenantId && hasScope(me, tenantId, 'write:affiliate-partners')))) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { onClick: () => setModalOpen(!modalOpen), style: {
                cursor: 'pointer',
                color: THEME.COLOR_ACCENT,
                fontWeight: 'bold',
                fontSize: '.7em',
                textTransform: 'uppercase',
                marginTop: '0',
            } },
            "Initiate DNS ",
            React.createElement(ExclusiveContentBadge, null)),
        modalOpen && (React.createElement(Modal, { header: 'Initiate DNS', onToggle: () => setModalOpen(!modalOpen), maxWidth: "500px" },
            React.createElement(InitiateDNS, { collectorId: props.collectorId })))));
};
export default InitiateDNS;
//# sourceMappingURL=InitiateDNS.js.map